import { toast } from 'sonner';
import { Download } from 'lucide-react';
import api from '@/utils/api';
import { errMsg } from '@/components/jobfairs/fairApi';

export const downloadBlob = async (url, filename, params) => {
  try {
    const r = await api.get(url, { params, responseType: 'blob' });
    const href = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) { toast.error(errMsg(e, 'Download failed')); }
};

export const FileLink = ({ fairId, file, label, testId }) => {
  if (!file?.key) return <span className="text-xs text-slate-400">—</span>;
  const ext = file.key.split('.').pop();
  return (
    <button type="button" data-testid={testId} onClick={() => downloadBlob(`/job-fairs/admin/${fairId}/file`, `${label.replace(/\s+/g, '_')}.${ext}`, { key: file.key })}
      className="inline-flex items-center gap-1 text-xs font-medium text-teal-700 hover:underline">
      <Download className="w-3.5 h-3.5" />{label.split('_').pop()}
    </button>
  );
};

export const show = (v) => {
  if (v === undefined || v === null || v === '') return '—';
  if (Array.isArray(v)) {
    if (!v.length) return '—';
    return v.map((x) => (typeof x === 'object' ? (x.role ? `${x.role}${x.positions ? ` (${x.positions})` : ''}` : x.display || x.city) : x)).join(', ');
  }
  return String(v);
};

export const fmtDate = (s) => (s ? new Date(s).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');

export const EMP_STATUS = {
  under_verification: ['Under Verification', 'bg-amber-100 text-amber-800'],
  approved: ['Approved', 'bg-emerald-100 text-emerald-800'],
  rejected: ['Rejected', 'bg-red-100 text-red-700'],
};

export const EmpStatus = ({ s, testId }) => {
  const [l, c] = EMP_STATUS[s] || EMP_STATUS.under_verification;
  return <span data-testid={testId} className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${c}`}>{l}</span>;
};
